import { Fragment } from 'react';
import { PERIODS } from 'utilities/global.variables';

const PeriodSelector = ({ period, setPeriod }) => (
  <div className='flex col center'>
  <div className="button-group regular bold">
    {PERIODS.map(p => (
      <Fragment key={p.value}>
        <input type="radio" name="assets-period" value={p.value} checked={period === p.value} readOnly />
        <label className="regular" onClick={() => setPeriod(p.value)}>{p.label}</label>
      </Fragment>
    ))}
  </div>
  </div>
);

export default PeriodSelector;
